/**
 * Follow Desk's light or night mode, from anywhere in the panel.
 *
 * This listener is deliberately not inside a component. The bridge hook lives
 * in the ticket view, so with the agent on a settings screen nothing was
 * listening and a switch in Desk changed nothing until they navigated back.
 * The theme is a property of the window, not of whichever screen is open.
 */
function apply(theme: unknown) {
  // Desk's "auto" means follow the device, which is exactly what the panel
  // does with no attribute set — so this releases it rather than pinning it.
  if (theme === 'auto') {
    delete document.documentElement.dataset.theme
    return
  }

  if (theme !== 'light' && theme !== 'dark') return
  document.documentElement.dataset.theme = theme
}

export function followDeskTheme() {
  window.addEventListener('message', (e: MessageEvent) => {
    // Only the frame that embedded us may drive this page.
    if (e.source !== parent) return

    const data = e.data as { type?: string; theme?: unknown } | undefined
    if (data?.type === 'THEME' || data?.type === 'TICKET_DATA') apply(data.theme)
  })
}
